import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./header.css";
import logo1 from "../../assets/logo1.jpeg";
import sideLogo from "../../assets/sideLogo7.png";
import { SlMenu } from "react-icons/sl";
import Modal from "react-bootstrap/Modal";
import UseMediaQuery from "./../Pages/UseMediaQuery";
import { FaXTwitter } from "react-icons/fa6";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
} from "react-icons/fa";

function Header() {
  const [show, setShow] = useState(false);
  const isMobile = UseMediaQuery("(max-width:990px)");
  const [menuOpen, setMenuOpen] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      {/* Navbar */}

      {isMobile ? (
        <>
          <nav className="container-fluid navbar navbar-expand-lg headerBg p-0 m-0 ">
            <div className="container d-flex justify-content-between align-items-center">
              {/* Logo */}
              <NavLink to="/" onClick={handleClose}>
                <img src={logo1} alt="Logo" className="headLogo" />
              </NavLink>

              {/* Menu Button */}
              <button
                className="navbar-toggler border-0 bg-transparent"
                type="button"
                onClick={handleShow}
                aria-label="Toggle navigation"
              >
                <SlMenu className="TithMenu" />
              </button>
            </div>
          </nav>
        </>
      ) : (
        <>
          <nav className="container-fluid navbar navbar-expand-lg headerBg ">
            <div className="container ">
              {/* Logo */}
              <NavLink to="/" onClick={closeMenu}>
                <img src={logo1} alt="Logo" className="headLogo col-md-2 " />
              </NavLink>

              {/* Menu Toggle Button */}
              <button
                className="navbar-toggler "
                type="button"
                onClick={toggleMenu}
                aria-label="Toggle navigation"
              >
                {menuOpen ? (
                  <span className="close-icon">✖</span>
                ) : (
                  <span className="navbar-toggler-icon ">
                    <SlMenu className="TithMenu" />
                  </span>
                )}
              </button>

              {/* Navigation Links */}
              <div
                className={`collapse navbar-collapse col-md-6  ${
                  menuOpen ? "show" : ""
                }`}
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav ms-auto headerLinks ">
                  {[
                    { to: "/", label: "Home" },
                    { to: "/services", label: "Service" },
                    { to: "/about-us", label: "About" },
                    { to: "/contact-us", label: "Contact" },
                  ].map((item, index) => (
                    <li className="nav-item" key={index}>
                      <NavLink
                        to={item.to}
                        className={({ isActive }) =>
                          isActive ? "nav-link active" : "nav-link"
                        }
                        onClick={closeMenu}
                      >
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
              {/* <div className=" col-md-2 headerLinks3">
                <p className="headerLinks2 mt-3 ">Schedule the consult</p>
              </div> */}
              <div className=" col-md-3">
                <h3 className="sideLogoh mt-1 mb-0">
                  Made in India with Pride
                </h3>
                <p className="sideLogop  m-0">For the people, for the nation</p>
                <div className="d-flex justify-content-end">
                  <img src={sideLogo} alt="" className="sideLogoImg " />
                </div>
              </div>
            </div>
          </nav>
        </>
      )}

      {/* Modal for Menu */}
      <Modal
        show={show}
        onHide={handleClose}
        // fullscreen={isMobile}
        size={isMobile ? "lg" : "lg"}
        dialogClassName={`menuModal  ${show ? "show" : ""}`} // 👈 ADD THIS
        end
      >
        <Modal.Body style={{ backgroundColor: "rgb(14, 16, 52)" }}>
          <div className="container ">
            <div className="d-flex justify-content-end align-items-center mb-xl-1 mb-lg-1 mb-md-2 mb-sm-2 mb-2 p-0">
              <span className="close-icon" onClick={handleClose}>
                ✖
              </span>
            </div>

            {isMobile ? (
              <>
                <ul className="navbar-nav text-center headerLinks">
                  <NavLink to="/">
                    <img src={logo1} alt="Logo" className="headLogo" />
                  </NavLink>
                  {[
                    { to: "/", label: "Home" },
                    { to: "/services", label: "Service" },
                    { to: "/about-us", label: "About" },
                    { to: "/contact-us", label: "Contact" },
                  ].map((item, index) => (
                    <li className="nav-item mb-3" key={index}>
                      <NavLink
                        to={item.to}
                        className={({ isActive }) =>
                          isActive ? "nav-link active" : "nav-link"
                        }
                        onClick={handleClose}
                      >
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                  <div className="col-12 hrFooter mt-1  mb-3"></div>
                </ul>
                {/* <div className="col-md-2 sideDflex">
                  <img src={sideLogo} alt="" className="sideLogoImg" />
                </div> */}
                <div className=" col-md-8 col-sm-8 col-12 col-lg-2 col-xl-2 ">
                  <h3 className="sideLogoh mt-1 mb-0">
                    Made in India with Pride
                  </h3>
                  <p className="sideLogop  m-0">
                    For the people, for the nation
                  </p>
                  <div className="mobDlex">
                    {" "}
                    <img src={sideLogo} alt="" className="sideLogoImg " />
                  </div>
                </div>
              </>
            ) : (
              <>
                {" "}
                <NavLink to="/">
                  <img src={logo1} alt="Logo" className="headLogo" />
                </NavLink>
              </>
            )}
          </div>

          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footerIcon">
                  <ul className="d-flex mobileDflex2 flex-wrap gap-3 p-0 my-xl-5 my-lg-5 my-md-4 my-sm-4 my-3  ulFooter">
                    <li>
                      <Link to="https://www.facebook.com/login/">
                        <FaFacebookF className="footerIcon1" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.instagram.com/accounts/login">
                        <FaInstagram className="footerIcon2" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://x.com/i/flow/login">
                        <FaXTwitter className="footerIcon3" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.linkedin.com/login">
                        <FaLinkedinIn className="footerIcon4" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.youtube.com/account">
                        <FaYoutube className="footerIcon5" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Header;
